import { render, staticRenderFns } from "./ProductItemsix.vue?vue&type=template&id=53f70e2e&scoped=true"
import script from "./ProductItemsix.vue?vue&type=script&lang=js"
export * from "./ProductItemsix.vue?vue&type=script&lang=js"
import style0 from "./ProductItemsix.vue?vue&type=style&index=0&id=53f70e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f70e2e",
  null
  
)

export default component.exports